import React, { FunctionComponent, ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

type InfiniteScrollerProps = {
    children: any;
    data: unknown[];
    loader: ReactNode;
    loadMore: Function;
    dataHasMore: boolean;
    scrollableTarget?: string;
    handleScroll: Function;
};
const InfiniteScroller: FunctionComponent<InfiniteScrollerProps> = (props) => {
    const { children, data, loader, loadMore, dataHasMore, scrollableTarget, handleScroll } = props;

    const fetchMoreData = () => {
        loadMore();
    };

    return (
        <InfiniteScroll
            dataLength={data.length}
            next={fetchMoreData}
            hasMore={dataHasMore}
            loader={loader}
            scrollableTarget={scrollableTarget}
            style={{ height: '100%', overflow: 'hidden' }}
            onScroll={(e) => handleScroll(e)}
        >
            {children}
        </InfiniteScroll>
    );
};

export default InfiniteScroller;
